export default ["M8 0a8 8 0 100 16A8 8 0 108 0z"];